import { client as apiClient } from '../api/client';
import { SetupIntent } from '../models';

interface ApiSetupIntent {
  client_secret: string;
}

export class SubscriptionRepository {
  public async createSetupIntent(): Promise<SetupIntent> {
    const response = await apiClient.post(`subscription/setup`);

    const responseJson = (await response.json()) as { data: ApiSetupIntent };

    return this.buildSetupIntent(responseJson.data);
  }

  public async subscribe(
    planId: string,
    paymentMethodId: string
  ): Promise<void> {
    await apiClient.post(`subscription`, {
      plan_id: planId,
      payment_method: paymentMethodId
    });
  }

  public async updateCard(paymentMethodId: string): Promise<void> {
    await apiClient.put(`subscription`, {
      payment_method: paymentMethodId
    });
  }

  public async cancelMembership(): Promise<Date> {
    const response = await apiClient.delete(`subscription`);

    const responseJson = (await response.json()) as {
      data: { premium_ends_at: string };
    };

    return new Date(responseJson.data.premium_ends_at);
  }

  private buildSetupIntent = (data: ApiSetupIntent): SetupIntent => {
    return new SetupIntent(data.client_secret);
  };
}

let RepositoryClass: ImportedModule<Constructable<SubscriptionRepository>>;
if (process.env.REACT_APP_NO_BACKEND === 'true') {
  RepositoryClass = require('./SubscriptionMock');
} else {
  RepositoryClass = { default: SubscriptionRepository };
}

let repository: SubscriptionRepository;
export default function getRepository() {
  if (!repository) {
    repository = new RepositoryClass.default();
  }

  return repository;
}



// WEBPACK FOOTER //
// ./src/app/repositories/Subscription.ts